import { FREESPIN, FREEBET } from '../../constants/index.js';
// import { ActiveActivityPresentation, ActiveSportsbookActivityPresentation } from '../account/my-activities/types';
import { Item } from '../item-detail-view/item-detail-view-types';

// Type definitions
interface ItemCostParams {
	ppAmount?: number;
	playerPointCost?: number;
	playerPointsCost?: number;
	playersPointCost?: number;
}

// interface Item {
// 	type?: string;
// 	TYPE?: string;
// 	productCategoryCodes?: string[];
// 	id: number;
// }

interface PaymentMethodItem {
	item?: {
		paymentMethodsIds?: number[];
		paymentMethodIdsStr?: string;
	};
	paymentMethodsIds?: number[];
	paymentMethodIdsStr?: string;
}

interface Translations {
	SHOP_GET_FREESPIN: string;
	SHOP_GET_FREEBET: string;
	MARKETPLACE_BUY_WITH_POINTS: string;
	MARKETPLACE_GET_BONUS: string;
}

/**
 * Helper function to get item cost from various possible properties
 */
export const itemCostHelper = ({
	ppAmount,
	playerPointCost,
	playerPointsCost,
	playersPointCost
}: ItemCostParams): string | undefined => {
	if (ppAmount || ppAmount === 0) return ppAmount.toString();
	if (playerPointCost || playerPointCost === 0) return playerPointCost.toString();
	if (playerPointsCost || playerPointsCost === 0) return playerPointsCost.toString();
	if (playersPointCost || playersPointCost === 0) return playersPointCost.toString();
	return undefined;
};

/**
 * Gets the appropriate button text for detail view items
 */
export const getDetailViewItemButtonText = (item: Item, itemCost: number, translations: Translations): string => {
	return item.type === FREESPIN
		? translations.SHOP_GET_FREESPIN
		: item.type === FREEBET
			? translations.SHOP_GET_FREEBET
			: item.TYPE === FREEBET && itemCost > 0
				? translations.MARKETPLACE_BUY_WITH_POINTS
				: translations.MARKETPLACE_GET_BONUS;
};

/**
 * Filters items by selected split category
 */
export const filterItemsBySelectedSplitCategory = (allItems: Item[], category: string): Item[] => {
	return allItems.filter(item => item.productCategoryCodes?.includes(category));
};

/**
 * Checks if campaign category matches split category
 */
export const campaignMatchingSplitCategory = (campaignCategory: string, splitCategory: string): boolean =>
	campaignCategory?.includes(splitCategory);

/**
 * Helper for filtering items in my activities split
 */
export const myActivitiesSplitItemsChecker = (
	filteringCondition: boolean,
	allItems: Item[],
	category: string
): Item[] => (filteringCondition ? filterItemsBySelectedSplitCategory(allItems, category) : allItems);

/**
 * Helper function for payment methods
 * @param item - shop object
 * @returns 'ALL' or comma-separated payment method IDs
 */
export const paymentMethodsHelper = (item: PaymentMethodItem): string => {
	let bonusPaymentMethods = 'ALL';
	if (item.item && item.item.paymentMethodsIds !== undefined && item.item.paymentMethodsIds.length > 0) {
		bonusPaymentMethods = item.item.paymentMethodsIds.join();
	} else if (item.item && item.item.paymentMethodIdsStr) {
		bonusPaymentMethods = item.item.paymentMethodIdsStr;
	}

	if (item && item.paymentMethodsIds !== undefined && item.paymentMethodsIds.length > 0) {
		bonusPaymentMethods = item.paymentMethodsIds.join();
	} else if (item.paymentMethodIdsStr) {
		bonusPaymentMethods = item.paymentMethodIdsStr;
	}

	return bonusPaymentMethods;
};

/**
 * Formats a number with comma separators for thousands
 * @param num - The number to format
 * @returns The formatted number with commas (e.g., 1000 -> "1,000")
 */
export const formatNumberWithCommas = (num: number | null | undefined): string => {
	if (num === null || num === undefined || Number.isNaN(Number(num))) return '0';
	const numValue = Number(num);
	return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
